module.exports = __webpack_public_path__ + "img/201612-2-768x1024.ffc777a9.jpg";